import React from 'react';
import styles from 'src/pages/Design/pages/ForestWelcomeParallax/ForestWelcomeParallax.module.scss'
import MountainPng from 'src/pages/Design/pages/ForestWelcomeParallax/assets/Mountain.png'
import TreesPng from 'src/pages/Design/pages/ForestWelcomeParallax/assets/Trees.png'


const ForestWelcomeParallax: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.welcomeSection}>
        <img
          className={styles.background}
          src={MountainPng}
        />
        <img
          className={styles.foreground}
          src={TreesPng}
        />
        <h1 className={styles.title}>Welcome!</h1>
      </div>
      <div className={styles.forestDescription}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum
        totam aperiam eos alias sunt pariatur enim quibusdam, ad officia.
        Assumenda, eveniet. Esse aliquid alias eius odio, et error officiis
        odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Voluptatum totam aperiam eos alias sunt pariatur enim quibusdam, ad
        officia. Assumenda, eveniet. Esse aliquid alias eius odio, et error
        officiis odit.
      </div>
    </div>
  );
};

export default ForestWelcomeParallax;
